import adunitGroup from "./messages/adunitGroup";
import analytics from "./messages/analytics";
import engagement from "./messages/engagement";
import idManager from "./messages/idManager";
import general from "./messages/general";
import helpCenter from "./messages/helpCenter";
import home from "./messages/home";
import login from "./messages/login";
import notFound from "./messages/notFound";
import settings from "./messages/settings";
import layout from "./messages/layout";
import unAuthorized from "./messages/unAuthorized";
import wrapper from "./messages/wrapper";
import coreWebVitals from "./messages/coreWebVitals";
import releaseNote from "./messages/releaseNote";

export default {
  ...adunitGroup,
  ...analytics,
  ...engagement,
  ...idManager,
  ...general,
  ...helpCenter,
  ...home,
  ...login,
  ...notFound,
  ...settings,
  ...layout,
  ...unAuthorized,
  ...wrapper,
  ...coreWebVitals,
  ...releaseNote,
};
